import type { JSX } from "react";
import i18n from "@/lib/i18n";

interface ErrorPageProps {
	readonly error?: Error;
}

export default function ErrorPage({ error }: ErrorPageProps): JSX.Element {
	return (
		<div className="flex h-screen flex-col items-center justify-center gap-2 px-6 text-center">
			<h1 className="font-bold text-2xl">{i18n.t("errors.authInit")}</h1>
			{error ? <p className="sr-only">{error.message}</p> : null}
		</div>
	);
}
